import React, { useState } from 'react';
import { connect } from 'react-redux';
import './DebugPanel.css';

const DebugPanel = ({ userSearchData, enabled = true }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isPanelEnabled, setIsPanelEnabled] = useState(enabled);

  // Only show in development mode
  if (process.env.NODE_ENV !== 'development' || !isPanelEnabled) {
    return null;
  }

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleEnabled = () => {
    setIsPanelEnabled(!isPanelEnabled);
    if (!isPanelEnabled) {
      setIsVisible(true);
    }
  };

  // Format JSON with indentation for better readability
  const formatJSON = (obj) => {
    try {
      return JSON.stringify(obj, null, 2);
    } catch (e) {
      return 'Error formatting JSON';
    }
  };

  return (
    <div className={`debug-panel ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="debug-panel-header">
        <div className="debug-panel-title">Debug Panel</div>
        <div className="debug-panel-controls">
          <button onClick={toggleExpand}>
            {isExpanded ? 'Collapse' : 'Expand'}
          </button>
          <button onClick={toggleVisibility}>
            {isVisible ? 'Minimize' : 'Show'}
          </button>
          <button onClick={toggleEnabled}>
            {isPanelEnabled ? 'Disable' : 'Enable'}
          </button>
        </div>
      </div>
      {isVisible && (
        <div className={`debug-panel-content ${isExpanded ? 'expanded' : ''}`}>
          <h3>User Search Data:</h3>
          <pre>{formatJSON(userSearchData)}</pre>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  userSearchData: state.mainReducerData?.userSearchData || {}
});

export default connect(mapStateToProps)(DebugPanel);
